import * as React from 'react';
import './App.css';

import { Switch, Route, Redirect } from 'react-router-dom';
import ProtectedRoute from './common/routes/protected-route';

import Header from './common/header/header';
import Login from './features/login/login';
import NotFound from './common/routes/not-found';
import SessionExpired from './common/routes/session-expired';
import CustomerTable from './features/customer-table/customer-table';
import Customer from './features/customer/customer';
import LicenseEntry from './features/license-entry/license-entry';
import User from './features/user/user';
import UserTable from './features/user-table/user-table';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Header />

        <main>
          <Switch>
            <Redirect
              path="/"
              exact
              to={{ pathname: '/customers', state: { from: '/' } }}
            />
            <ProtectedRoute exact path="/users" component={UserTable} />
            <ProtectedRoute exact path="/users/new" component={User} />
            <ProtectedRoute exact path="/customers" component={CustomerTable} />
            <ProtectedRoute exact path="/customers/new" component={Customer} />
            <ProtectedRoute
              exact
              path="/customers/view/:id"
              component={Customer}
            />
            <ProtectedRoute
              exact
              path="/licenses/new/:customerId"
              component={LicenseEntry}
            />
            <ProtectedRoute
              exact
              path="/licenses/view/:id"
              component={LicenseEntry}
            />
            <ProtectedRoute
              exact
              path="/licenses/copy/:parentId"
              component={LicenseEntry}
            />
            <ProtectedRoute exact path="/users/view/:id" component={User} />
            <Route exact path="/session-expired" component={SessionExpired} />
            <Route exact path="/login" component={Login} />
            <Route component={NotFound} />
          </Switch>
        </main>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx